<template>
    <div class="w-100 login-right pr-5 pt-5">
        <div class="d-block login-text text-right">
            <span class="float-left pl-5"><a href="javascript:void(0)"  @click="goBack()" class="no-style">< назад</a></span>
            <span class="login-text">
                <a href="/#/reg/person" class="no-style">Регистрация</a>
            </span>
        </div>
        <div class="reg-form pt-5">
            <h5 class="reg-title text-center">Войти в аккаунт</h5>
            <div class="url-container text-center py-3">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 11C10.7274 11 9.14844 11.0646 7.85838 11.1466C6.63471 11.2243 5.69379 12.158 5.60597 13.373C5.5435 14.2373 5.5 15.1481 5.5 16C5.5 16.8519 5.5435 17.7627 5.60597 18.627C5.69379 19.842 6.63471 20.7757 7.85838 20.8534C9.14844 20.9354 10.7274 21 12.5 21C14.2726 21 15.8516 20.9354 17.1416 20.8534C18.3653 20.7757 19.3062 19.842 19.394 18.627C19.4565 17.7627 19.5 16.8519 19.5 16C19.5 15.1481 19.4565 14.2373 19.394 13.373C19.3062 12.158 18.3653 11.2243 17.1416 11.1466C15.8516 11.0646 14.2726 11 12.5 11ZM7.7315 9.15059C5.51376 9.29156 3.77137 11.0124 3.61117 13.2288C3.54652 14.1234 3.5 15.085 3.5 16C3.5 16.915 3.54652 17.8766 3.61118 18.7712C3.77137 20.9876 5.51376 22.7084 7.73151 22.8494C9.05778 22.9337 10.6795 23 12.5 23C14.3205 23 15.9422 22.9337 17.2685 22.8494C19.4862 22.7084 21.2286 20.9876 21.3888 18.7712C21.4535 17.8766 21.5 16.915 21.5 16C21.5 15.085 21.4535 14.1234 21.3888 13.2288C21.2286 11.0124 19.4862 9.29156 17.2685 9.15059C15.9422 9.06629 14.3205 9 12.5 9C10.6795 9 9.05778 9.06629 7.7315 9.15059Z" fill="#58BD7D"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 16.7324C14.0978 16.3866 14.5 15.7403 14.5 15C14.5 13.8954 13.6046 13 12.5 13C11.3954 13 10.5 13.8954 10.5 15C10.5 15.7403 10.9022 16.3866 11.5 16.7324V18C11.5 18.5523 11.9477 19 12.5 19C13.0523 19 13.5 18.5523 13.5 18V16.7324Z" fill="#58BD7D"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 6C7.5 3.23858 9.73858 1 12.5 1C15.2614 1 17.5 3.23858 17.5 6V10C17.5 10.5523 17.0523 11 16.5 11C15.9477 11 15.5 10.5523 15.5 10V6C15.5 4.34315 14.1569 3 12.5 3C10.8431 3 9.5 4.34315 9.5 6V10C9.5 10.5523 9.05228 11 8.5 11C7.94772 11 7.5 10.5523 7.5 10V6Z" fill="#58BD7D"/>
                </svg>
                <span class="text-success ml-2">https://</span><span>payton.kz/register/user</span>
            </div>
            <div class="sm-sep mt-4"></div>
            <div class="btn-container text-center mt-4">
                <div class="d-inline-block active-btn-container px-3 py-2 mr-5">
                    <span class="active-btn-text">Физ.лицо</span>
                </div>
                <a
                    href="javascript:void(0)"
                    class="d-inline-block inactive-btn-container px-3 py-2"
                    style="text-decoration: none;"
                    @click.prevent="onLegalEntityComingSoon"
                >
                    <span class="inactive-btn-text">Юр лицо</span>
                </a>
            </div>
            <div class="sm-sep mt-4"></div>
            <div class="input-container">
                <!-- Step 1: email + password -->
                <b-form v-if="step === 'credentials'" v-on:submit.prevent="handleLoginFormSubmit">
                    <b-form-row class="mt-3">
                        <b-col sm="auto" lg="12">
                            <label for="email" class="reg-label">{{$t('regForm.email')}}</label>
                            <input type="email"  id="email"
                                class="reg-input w-100 p-2"
                                required
                                v-model="login.username">
                        </b-col>
                    </b-form-row>
                    <b-form-row class="mt-3">
                        <b-col sm="auto" lg="12">
                            <label for="password" class="reg-label">{{$t('regForm.password')}}</label>
                            <div class="password-wrapper">
                                <input :type="showPassword ? 'text' : 'password'" id="password"
                                    class="reg-input w-100 p-2"
                                    required
                                    v-model="login.password">
                                <button type="button" class="password-toggle" @click="showPassword = !showPassword" tabindex="-1">
                                    <b-icon :icon="showPassword ? 'eye-slash' : 'eye'"></b-icon>
                                </button>
                            </div>
                        </b-col>
                    </b-form-row>

                    <b-form-row class="mt-3">
                        <b-col sm="auto" lg="12">
                            <div class="text-right forgot-password">
                                <a href="javascript:void(0)" class="no-style" @click="$router.push('/forgot-password')">{{$t('regForm.forgotPassword')}}</a>
                            </div>
                            <button type="submit" class="submit-btn w-100 py-2 mt-4" :disabled="busy">
                                <span class="submit-btn-text">{{$t('regForm.loginText')}}</span>
                            </button>
                            <div class="text-center mt-3 no-account-text">
                                Ещё нет аккаунта?
                                <a href="/#/reg/person" class="create-account-link">Создать аккаунт</a>
                            </div>
                        </b-col>
                    </b-form-row>
                </b-form>

                <!-- Step 2: 2FA code (TOTP or one-time backup) -->
                <b-form v-else-if="step === 'twofa'" v-on:submit.prevent="handleTwoFASubmit">
                    <p class="text-center mt-4 mb-3" style="color: var(--Neutrals-5, #B1B5C3);">
                        <b-icon icon="shield-lock" class="mr-2" />
                        Подтверждение двухфакторной аутентификации
                    </p>
                    <b-form-row v-if="!useBackup" class="mt-3">
                        <b-col sm="auto" lg="12">
                            <label class="reg-label">Код из приложения-аутентификатора</label>
                            <input type="text" class="reg-input w-100 p-2 code-input"
                                placeholder="000000" maxlength="6" inputmode="numeric"
                                autocomplete="one-time-code"
                                v-model="twofa.code" required>
                        </b-col>
                    </b-form-row>
                    <b-form-row v-else class="mt-3">
                        <b-col sm="auto" lg="12">
                            <label class="reg-label">Резервный код</label>
                            <input type="text" class="reg-input w-100 p-2"
                                placeholder="xxxx-xxxx"
                                v-model="twofa.backupCode" required>
                        </b-col>
                    </b-form-row>
                    <b-form-row class="mt-3">
                        <b-col sm="auto" lg="12">
                            <button type="submit" class="submit-btn w-100 py-2 mt-3" :disabled="busy">
                                <span class="submit-btn-text">Войти</span>
                            </button>
                            <div class="text-center mt-3 no-account-text">
                                <a href="javascript:void(0)" class="create-account-link"
                                    @click="useBackup = !useBackup">
                                    {{ useBackup ? 'Использовать код из приложения' : 'Использовать резервный код' }}
                                </a>
                            </div>
                            <div class="text-center mt-2 no-account-text">
                                <a href="javascript:void(0)" class="no-style"
                                    @click="resetToCredentials">< Назад</a>
                            </div>
                        </b-col>
                    </b-form-row>
                </b-form>
            </div>
        </div>
        
    </div>
    </template>
    <script>
        import axios from 'axios';
        import {apiDomain, getHeader, loginUrl} from "@/config/config";
        const authUser = {};
        export default{

            name:"RLogin",

            data(){
                return{
                    login:{
                        username:'',
                        password:''
                    },
                    showPassword: false,

                    // Login is a two-step flow when the user has 2FA enabled:
                    // 'credentials' = email+password, 'twofa' = 6-digit code.
                    step: 'credentials',
                    busy: false,
                    useBackup: false,
                    twofa: {
                        preAuthToken: '',
                        code: '',
                        backupCode: '',
                    },
                }
            },
            methods:{
                goBack() {
                    if (window.history.length > 1) {
                        window.history.back();
                    } else {
                        this.$router.push("/landing");
                    }
                },
                onLegalEntityComingSoon() {
                    if (this.$bvToast) {
                        this.$bvToast.toast('Регистрация для юридических лиц пока в разработке.', {
                            title: 'В разработке',
                            variant: 'info',
                            autoHideDelay: 4500,
                            toaster: 'b-toaster-top-center',
                            solid: true,
                        });
                    }
                },
                handleLoginFormSubmit(){
                    this.busy = true;
                    axios.post(loginUrl,{
                    'username':this.login.username,
                    'password':this.login.password
                    }, {headers: getHeader()})
                    .then((res)=>{
                        if (res.status !== 200) return;

                        // Three possible shapes:
                        //  1) {access_token, refresh_token}            — login complete
                        //  2) {requires_2fa, pre_auth_token}            — show TOTP step
                        //  3) {requires_2fa_setup, pre_auth_token}      — force enrollment
                        if (res.data && res.data.requires_2fa_setup) {
                            window.localStorage.setItem('pendingTwoFA', JSON.stringify({
                                preAuthToken: res.data.pre_auth_token,
                            }));
                            this.$router.push('/2fa-setup');
                            return;
                        }
                        if (res.data && res.data.requires_2fa) {
                            this.twofa.preAuthToken = res.data.pre_auth_token;
                            this.twofa.code = '';
                            this.twofa.backupCode = '';
                            this.useBackup = false;
                            this.step = 'twofa';
                            return;
                        }
                        authUser.access_token = res.data.access_token;
                        authUser.refresh_token = res.data.refresh_token;
                        window.localStorage.setItem('authUser', JSON.stringify(authUser));
                        this.$router.push({name:'AfterAuth'});
                    })
                    .catch((err) => {
                        const status = err && err.response && err.response.status;
                        const body = err && err.response && err.response.data;
                        const txt = typeof body === 'string' ? body : '';
                        // Бэкенд отдаёт 403 и для заблокированного аккаунта
                        // (body 'blocked'), и для неподтверждённого email
                        // (body 'email-not-verified') — различаем по телу.
                        if (status === 403 && txt.indexOf('blocked') !== -1) {
                            this.blockedToast(this.login.username);
                            return;
                        }
                        if (status === 403) {
                            this.toast(this.$t('regForm.emailNotVerified'), 'warning');
                            return;
                        }
                        this.toast(this.$t('regForm.wrongLogin'), 'danger');
                    })
                    .finally(() => { this.busy = false; });
                },
                handleTwoFASubmit(){
                    this.busy = true;
                    const payload = { preAuthToken: this.twofa.preAuthToken };
                    if (this.useBackup) {
                        payload.backupCode = this.twofa.backupCode.trim();
                    } else {
                        payload.code = this.twofa.code.trim();
                    }
                    axios.post(apiDomain + '/login/verify-2fa', payload)
                        .then((res) => {
                            authUser.access_token = res.data.access_token;
                            authUser.refresh_token = res.data.refresh_token;
                            window.localStorage.setItem('authUser', JSON.stringify(authUser));
                            // Stash a flag for the post-login toast. The
                            // Landing layout reads + clears it on mount, so
                            // it fires exactly once after redirect.
                            if (res.data.used_backup_code) {
                                window.sessionStorage.setItem('tfaBackupLogin', JSON.stringify({
                                    backupCodesLeft: res.data.backup_codes_left || 0,
                                }));
                            }
                            this.$router.push({name:'AfterAuth'});
                        })
                        .catch((err) => {
                            const body = err && err.response && err.response.data;
                            const txt = typeof body === 'string' ? body : '';
                            if (txt.includes('invalid-code')) {
                                this.toast('Неверный код. Сверьте часы на устройстве с приложением.', 'danger');
                            } else if (txt.includes('invalid-backup-code')) {
                                this.toast('Резервный код недействителен или уже использован.', 'danger');
                            } else if (txt.includes('invalid-pre-auth-token') || txt.includes('expired')) {
                                this.toast('Срок входа истёк. Войдите снова.', 'warning');
                                this.resetToCredentials();
                            } else {
                                this.toast('Не удалось войти. Попробуйте ещё раз.', 'danger');
                            }
                        })
                        .finally(() => { this.busy = false; });
                },
                resetToCredentials() {
                    this.step = 'credentials';
                    this.twofa = { preAuthToken: '', code: '', backupCode: '' };
                    this.useBackup = false;
                },
                toast(message, variant) {
                    if (!this.$bvToast) {
                        return;
                    }
                    const titleKey = variant === 'warning' ? 'system.warningTitle' : 'system.errorTitle';
                    this.$bvToast.toast(message, {
                        title: this.$t(titleKey),
                        variant: variant || 'danger',
                        autoHideDelay: 5000,
                        toaster: 'b-toaster-top-center',
                        solid: true,
                    });
                },
                // Отдельное сообщение для заблокированного аккаунта — с email
                // и подсказкой обратиться в поддержку. Держим дольше на экране.
                blockedToast(email) {
                    if (!this.$bvToast) {
                        return;
                    }
                    this.$bvToast.toast(
                        `Ваша учетная запись ${email} заблокирована. Обратитесь в службу поддержки, чтобы узнать подробности.`,
                        {
                            title: 'Вход заблокирован',
                            variant: 'danger',
                            autoHideDelay: 9000,
                            toaster: 'b-toaster-top-center',
                            solid: true,
                        }
                    );
                }
            
            }        
        }
        
    </script>
    <style scoped>
        .password-wrapper {
            position: relative;
        }
        .password-wrapper .reg-input {
            padding-right: 2.5rem !important;
        }
        .password-toggle {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            background: none;
            border: none;
            padding: 0;
            cursor: pointer;
            color: var(--Neutrals-4, #777E90);
            display: flex;
            align-items: center;
        }
        .password-toggle:hover {
            color: var(--Neutrals-8, #FCFCFD);
        }
        .code-input {
            font-size: 22px !important;
            letter-spacing: 6px;
            text-align: center;
        }
        .forgot-password{
            color: var(--Primary-1, #EFB914);
            text-align: right;
            font-family: Inter;
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px;
        }
        .url-container{
            border-radius: 8px;
            background: var(--Neutrals-2, #23262F);
            color: var(--Neutrals-8, #FCFCFD);
            text-align: center;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
        }
        .submit-btn{
            appearance: none; 
            -webkit-appearance: none;
            -moz-appearance: none;
            cursor: pointer;
            border-radius: 12px;
            border:1px solid var(--Primary-1, #EFB914);
            background: var(--Primary-1, #EFB914);
        }
        .submit-btn-text{
            color: var(--Neutrals-8, #FCFCFD);
            text-align: center;
            font-family: Inter;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 16px;
        }
        .reg-label{
            color: var(--Neutrals-5, #B1B5C3);
            font-family: Inter;
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: 12px; /* 100% */
            text-transform: uppercase;
        }
        .reg-input{
            color: var(--Neutrals-4, #777E90);
    
            /* Caption (Bold) */
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px; /* 171.429% */
            appearance: none; 
            -webkit-appearance: none;
            -moz-appearance: none;
            background-color: transparent;
            border: none;
            outline: none;
            font-family: inherit;
            font-size: inherit;
            
            line-height: inherit;
            padding: 0;
            margin: 0;
            border-radius: 12px;
            border: 2px solid var(--Neutrals-3, #353945);
            
        }
        .custom-select {
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            background-color: transparent;
            border: none;
            outline: none;
            font-family: inherit;
            font-size: inherit;
            line-height: inherit;
            padding: 0 20px 0 0; /* Adjust padding to leave space for custom arrow */
            margin: 0;
            border-radius: 12px;
            border: 2px solid var(--Neutrals-3, #353945);
            position: relative;
        }
    
        .custom-select::after {
            content: '\25BC'; /* Unicode character for down arrow */
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
            pointer-events: none;
            color: var(--Neutrals-4, #777E90); /* Match arrow color with text color */
        }
        .sm-sep{
            height: 1px;
            border-radius: 1px;
            background: var(--Neutrals-3, #353945);
        }
        .inactive-btn-text{
            color: var(--Neutrals-8, #FCFCFD);
            text-align: center;
            font-family: Inter;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 16px;
        }
        .inactive-btn-container{
            cursor: pointer;
            border-radius: 12px;
            border: 2px solid var(--Neutrals-4, #777E90);
        }
        .active-btn-text{
            color: var(--Neutrals-8, #FCFCFD);
            text-align: center;
            font-family: Inter;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 16px;
        }
        .active-btn-container{
            cursor: pointer;
            border-radius: 12px;
            background: var(--Primary-1, #EFB914);
        }
        .reg-title{
            color: var(--Neutrals-8, #FCFCFD);
            text-align: center;
            font-family: Inter;
            font-size: 40px;
            font-style: normal;
            font-weight: 700;
            line-height: 48px;
            letter-spacing: -1.2px;
        }
        .reg-form{
            display: block;
            width: 100%;
            max-width: 380px;
            margin: 0 auto;
        }
        .no-style {
            color: inherit; /* Inherit color from parent */
            text-decoration: none; /* Remove underline */
        }
        .login-text{
            color: var(--Primary-1, #EFB914);
            text-align: center;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 16px;
        }
        .have-account{
            color: var(--Neutrals-8, #FCFCFD);
            text-align: center;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 16px;
        }
        .login-right{
            background: var(--Neutrals-1, #141416);
            height: 110vh;
        }
        .no-account-text {
            color: var(--Neutrals-5, #B1B5C3);
            font-family: Inter;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
        }
        .create-account-link {
            color: var(--Primary-1, #EFB914);
            font-weight: 700;
            text-decoration: none;
        }
        .create-account-link:hover {
            text-decoration: underline;
        }
       

    </style>
    